function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMakePublic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "150px",
    height: "150px",
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 41.25 61.875 C 45.390625 61.875 48.75 58.515625 48.75 54.375 C 48.75 50.234375 45.390625 46.875 41.25 46.875 C 37.109375 46.875 33.75 50.234375 33.75 54.375 C 33.75 58.515625 37.109375 61.875 41.25 61.875 Z M 41.25 76.875 C 53.675781 76.875 63.75 66.800781 63.75 54.375 C 63.75 41.949219 53.675781 31.875 41.25 31.875 C 28.824219 31.875 18.75 41.949219 18.75 54.375 C 18.75 66.800781 28.824219 76.875 41.25 76.875 Z M 41.25 76.875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 41.625 82.5 C 35.414062 82.5 30.375 87.535156 30.375 93.75 L 30.375 105 C 30.375 109.140625 27.015625 112.5 22.875 112.5 C 18.734375 112.5 15.375 109.140625 15.375 105 L 15.375 93.75 C 15.375 79.253906 27.128906 67.5 41.625 67.5 C 56.125 67.5 67.875 79.253906 67.875 93.75 L 67.875 97.5 C 67.875 101.640625 64.519531 105 60.375 105 C 56.234375 105 52.875 101.640625 52.875 97.5 L 52.875 93.75 C 52.875 87.535156 47.839844 82.5 41.625 82.5 Z M 41.625 82.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 108.75 61.875 C 104.609375 61.875 101.25 58.515625 101.25 54.375 C 101.25 50.234375 104.609375 46.875 108.75 46.875 C 112.890625 46.875 116.25 50.234375 116.25 54.375 C 116.25 58.515625 112.890625 61.875 108.75 61.875 Z M 108.75 76.875 C 96.324219 76.875 86.25 66.800781 86.25 54.375 C 86.25 41.949219 96.324219 31.875 108.75 31.875 C 121.175781 31.875 131.25 41.949219 131.25 54.375 C 131.25 66.800781 121.175781 76.875 108.75 76.875 Z M 108.75 76.875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 108.375 82.5 C 114.589844 82.5 119.625 87.535156 119.625 93.75 L 119.625 105 C 119.625 109.140625 122.984375 112.5 127.125 112.5 C 131.265625 112.5 134.625 109.140625 134.625 105 L 134.625 93.75 C 134.625 79.253906 122.871094 67.5 108.375 67.5 C 93.878906 67.5 82.125 79.253906 82.125 93.75 L 82.125 97.5 C 82.125 101.640625 85.484375 105 89.625 105 C 93.765625 105 97.125 101.640625 97.125 97.5 L 97.125 93.75 C 97.125 87.535156 102.160156 82.5 108.375 82.5 Z M 108.375 82.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 75.375 103.125 C 69.164062 103.125 64.125 108.160156 64.125 114.375 L 64.125 125.625 C 64.125 129.765625 60.765625 133.125 56.625 133.125 C 52.484375 133.125 49.125 129.765625 49.125 125.625 L 49.125 114.375 C 49.125 99.878906 60.878906 88.125 75.375 88.125 C 89.875 88.125 101.625 99.878906 101.625 114.375 L 101.625 125.625 C 101.625 129.765625 98.269531 133.125 94.125 133.125 C 89.984375 133.125 86.625 129.765625 86.625 125.625 L 86.625 114.375 C 86.625 108.160156 81.589844 103.125 75.375 103.125 Z M 75.375 103.125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 97.5 75 C 97.5 87.425781 87.425781 97.5 75 97.5 C 62.574219 97.5 52.5 87.425781 52.5 75 C 52.5 62.574219 62.574219 52.5 75 52.5 C 87.425781 52.5 97.5 62.574219 97.5 75 Z M 97.5 75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 75 82.5 C 79.140625 82.5 82.5 79.140625 82.5 75 C 82.5 70.859375 79.140625 67.5 75 67.5 C 70.859375 67.5 67.5 70.859375 67.5 75 C 67.5 79.140625 70.859375 82.5 75 82.5 Z M 75 97.5 C 87.425781 97.5 97.5 87.425781 97.5 75 C 97.5 62.574219 87.425781 52.5 75 52.5 C 62.574219 52.5 52.5 62.574219 52.5 75 C 52.5 87.425781 62.574219 97.5 75 97.5 Z M 75 97.5 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMakePublic);
export default __webpack_public_path__ + "static/media/make-public.927f727abcc65eea0253cf5d906c05bb.svg";
export { ForwardRef as ReactComponent };